// Update view counts for blog posts if available
jQuery(document).on('pageviews-update', () => {
  setTimeout(() => {
    jQuery('.js-post-views').addClass('is-visible');
  }, 600);
});



// WEBPACK FOOTER //
// ./scripts/head.js